import { api } from "roboflex-thalamus-request-handler";

/**
 * KPIs de gestão de produção (injeção) — resposta alinhada ao payload consumido em GestaoProducaoKpis.vue.
 * @param {string} dtInicio yyyy-mm-dd
 * @param {string} dtFim yyyy-mm-dd
 * @param {number[]} [maquinaIds] ids de injetoras; array vazio ou omitido = todas
 */
export async function fetchGestaoProducaoKpis(dtInicio, dtFim, maquinaIds) {
  const params = {
    dt_inicio: dtInicio,
    dt_fim: dtFim,
  };
  const ids = Array.isArray(maquinaIds)
    ? [...new Set(maquinaIds.map((x) => Number(x)).filter((n) => !Number.isNaN(n) && n > 0))]
    : [];
  if (ids.length > 0) {
    params.maquina_ids = ids;
  }
  const response = await api.get("injecao/kpis/gestao-producao", { params });
  return response.data;
}

function buildDateParams(dtInicio, dtFim, maquinaIds) {
  const params = { dt_inicio: dtInicio, dt_fim: dtFim };
  const ids = Array.isArray(maquinaIds)
    ? [...new Set(maquinaIds.map((x) => Number(x)).filter((n) => !Number.isNaN(n) && n > 0))]
    : [];
  if (ids.length > 0) {
    params.maquina_ids = ids;
  }
  return params;
}

/** Relatório «Indicadores de Produção Injeção» (dashboard + PDF). */
export async function fetchRelatorioIndicadoresInjecao(dtInicio, dtFim, maquinaIds) {
  const { data } = await api.get("injecao/kpis/relatorio-indicadores-injecao", {
    params: buildDateParams(dtInicio, dtFim, maquinaIds),
  });
  return data;
}

/** Relatório «Usinagens» (Router / CNC). */
export async function fetchRelatorioUsinagens(dtInicio, dtFim) {
  const { data } = await api.get("injecao/kpis/relatorio-usinagens", {
    params: { dt_inicio: dtInicio, dt_fim: dtFim },
  });
  return data;
}

/**
 * Lista de injetoras para o filtro (mesmo endpoint do painel de injeção).
 * @returns {Promise<{ id: number, nome: string }[]>}
 */
export async function fetchMaquinasKpi() {
  const { data } = await api.get("injecao/maquina/listar");
  const list = Array.isArray(data) ? data : [];
  return list.map((m) => ({
    id: m.id,
    nome: m.nome != null ? String(m.nome) : "",
  }));
}
